import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import { createPinia } from 'pinia';
import VueSocialSharing from 'vue-social-sharing'
import App from './App.vue';
import router from './router';
import { getLanguageFile } from './i18n';

// import 'bootstrap/dist/css/bootstrap.min.css';
// Import Bootstrap JS bundle (includes Popper.js)
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
const langCode = document.documentElement.lang || 'en';

let isAppMounted = false;
getLanguageFile(langCode).then((messages) => {
  const container = document.getElementById('app');
  if (!container) {
    console.error('Mount container #app not found');
    return;
  }

  if (isAppMounted) {
    console.warn('Vue app already mounted, skipping mount');
    return;
  }

  const i18n = createI18n({
    locale: langCode,
    fallbackLocale: 'en',
    globalInjection: true,
    legacy: false,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    messages: messages as any,
  });
  createApp(App).use(i18n).use(createPinia()).use(router).use(VueSocialSharing).mount(container);
  isAppMounted = true;
});
